import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ChartCard, CrtDashboards, FormatAmountNumber } from '../../Base/Common/CommonUIComponents';
import { getColorPalette } from '../../Base/Common/ReferenceDataFunctions';
import { ErrorAlert } from "../../Base/ErrorAlert";
import { postAPI } from "../../Base/API";
import { Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';


class VouchersStats extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            error: [],
            block: false,
            usersByBrowser: [],
            usersByOS: [],
            usersByDevice: [],
            usersByPlataform: [],
            usersByScreenResolution: [],
            usersByDeviceModel: []
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.search === true && nextProps.search !== this.props.search) {
            this.getData();
            this.props.toggleSearch();
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.setState({ block: true });

        const body = {
            startDate: moment(this.props.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.props.endDate).format("YYYY-MM-DD"),
            dimensions: ["date", "eventName", "customEvent:hotelid", "customEvent:voucherid", "currencyCode"],
            metrics: ["eventCount", "eventValue"],
            aggregation: []
        }

        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                this.chartDataCalc(data);
            }
            else this.setState({ block: false });
        }, `/api/Voucher/Hotel/v1/googleanalytics`, body);
    }

    chartDataCalc = (data) => {
        var totalSales = 0, totalRevenue = 0;
        var revenuePerDay = [[this.props.intl.formatMessage({ id: "WidgetStatistics.Date" }), this.props.intl.formatMessage({ id: "WidgetStatistics.TotalRevenue" })]];
        var cartUsage = [["Voucher", this.props.intl.formatMessage({ id: "WidgetStatistics.AddedToCart" }), this.props.intl.formatMessage({ id: "WidgetStatistics.RemovedFromCart" })]];

        //Dates
        var currDate = moment(this.props.startDate);
        while (currDate.add(1, 'days').diff(this.props.endDate) < 0) {
            revenuePerDay.push([moment(currDate).format('YYYY-MM-DD'), 0]);
        }


        if (data.rows?.length > 0) {

            data.rows.forEach(row => {
                const voucherType = this.props.voucherTypes?.find(el => el.value?.toString() === row.dimensionValues[3].value?.toString()) || { value: row.dimensionValues[3].value, label: row.dimensionValues[3].value };
                
                const eventName = row.dimensionValues[1].value;
                const eventCount = parseInt(row.metricValues[0].value) ?? 0;
                const eventValue = parseFloat(row.metricValues[1].value) ?? 0;
                const date = row.dimensionValues[0].value;

                if (eventName === 'purchase') {
                    totalSales += eventCount;
                    totalRevenue += eventValue;

                    revenuePerDay = this.setValuesByDay(revenuePerDay, date, eventValue);
                }
                else if (eventName === 'promo_code_search') {
                }
                else if (eventName === 'add_to_cart' || eventName === 'remove_from_cart') {
                    const voucherIndex = cartUsage.findIndex(el => el[0] === voucherType.label);

                    if (voucherIndex === -1) {
                        cartUsage.push([voucherType.label, eventCount, 0]);
                    }
                    else {
                        cartUsage[voucherIndex][2] += (-eventCount);
                    }
                }
            })
        }

        this.setState({
            totalSales, totalRevenue,
            revenuePerDay, cartUsage,
            block: false
        });
    }

    setValuesByDay = (array, date, eventValue) => {
        const index = array.findIndex(el => moment(el[0]).isSame(date));

        if (index !== -1) {
            array[index][1] += eventValue;
        }

        return array;
    }


    render() {
        const { block, totalSales, totalRevenue, revenuePerDay, cartUsage } = this.state;
        
        const lineOptions = {
            legend: "none",
            vAxis: {
                minValue: 0,
            },
            series: [{ color: getColorPalette()[0] }]
        };

        return (
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={this.state.error} />
                <Row className="my-3">
                    <Col>
                        <CrtDashboards text={<FormattedMessage id="WidgetStatistics.TotalSales" />} value={totalSales ?? 0} />
                    </Col>
                    <Col>
                        <CrtDashboards text={<FormattedMessage id="WidgetStatistics.TotalRevenue" />} value={<FormatAmountNumber value={totalRevenue ?? 0}/>} />
                    </Col>
                </Row>

                <Row className="my-3">
                    <Col>
                        <ChartCard
                            chartType='LineChart'
                            data={revenuePerDay}
                            options={lineOptions}
                            title={<FormattedMessage id="WidgetStatistics.RevenuePerDay" />}
                        />
                    </Col>
                </Row>
                <Row className="my-3">
                    <Col>
                        <ChartCard
                            chartType='ColumnChart'
                            options={{
                                isStacked: true,
                                legend: "none",
                                colors: [getColorPalette()[0], '#ff7171']
                            }}
                            title={<FormattedMessage id="WidgetStatistics.ShoppingCartDetails" />}
                            data={cartUsage}
                        />
                    </Col>
                </Row>
            </BlockUi>
        )
    }
}

export default injectIntl(VouchersStats);
